/** Founder portfolio (GitHub Pages). */
export const FOUNDER_SITE_URL = 'https://navireddy369.github.io/NaviReddy369.github.oi/';

/** Portrait in `public/logos/founder.png` (bundled at build). */
export const FOUNDER_AVATAR_PATH = '/logos/founder.png';

export const FOUNDER_NAME = 'Naveen Gudimilla';

export const FOUNDER_TAGLINE = 'AI Enthusiast — site & portfolio';

/** localStorage: welcome / guide modal dismissed for this browser. */
export const WELCOME_STORAGE_KEY = 'gnk_welcome_modal_v1';
